// Close the current modal (if available) on navigation.
export default function ({ store }) {
    if (store.state.modalComponents.component) {
        store.dispatch('modal/close')
    }
}
